import React from 'react';
import { Bot } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useJarvis } from './JarvisProvider';
import { theme } from '../../../lib/theme';

export function JarvisFAB() {
    const { toggleChat, unreadCount, isOpen } = useJarvis();

    if (isOpen) return null;

    return (
        <motion.button
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            onClick={toggleChat}
            className={`fixed bottom-6 right-6 z-50 w-14 h-14 ${theme.colors.primaryBg} ${theme.radius.button} shadow-lg flex items-center justify-center text-white`}
        >
            <Bot size={28} />
            
            <AnimatePresence>
                {unreadCount > 0 && (
                    <motion.div
                        initial={{ scale: 0, y: 10 }}
                        animate={{ scale: 1, y: 0 }}
                        exit={{ scale: 0, y: 10 }}
                        className="absolute -top-1 -right-1 flex items-center justify-center"
                    >
                        {/* Pulse Effect */}
                        <span className="absolute inset-0 rounded-full bg-red-500 animate-ping opacity-40"></span>
                        
                        <div className="relative bg-red-600 text-white text-[10px] font-black w-6 h-6 rounded-full flex items-center justify-center border-2 border-white dark:border-slate-900 shadow-sm">
                            {unreadCount > 9 ? '9+' : unreadCount}
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </motion.button>
    );
}
